/**
 * API client for story analysis endpoints.
 *
 * Fetches the pre-computed ADAPT summary and learning insights
 * generated when a player session is completed.
 * @module analysisService
 */

import apiClient from '../lib/apiClient'

export const analysisService = {
  /**
   * Fetch the analysis for a completed player session.
   * Returns { status: 'processing' } when the backend is still generating (202),
   * or the full analysis data when ready (200).
   * @param {string|number} sessionId
   * @returns {Promise<Object>} Analysis data or processing status
   */
  async getAnalysis(sessionId) {
    const response = await apiClient.get(`/api/player_sessions/${sessionId}/analysis`)
    // 202 returns { status: "processing" } or { status: "upgrade_required" }
    if (response.status === 202) {
      return response.data
    }
    return response.data.data || response.data
  },

  /**
   * Fetch the user's cross-session profile analysis.
   * Returns { status: 'processing' } when generating (202),
   * or the full profile analysis data when ready (200).
   * @returns {Promise<Object>} Profile analysis data or processing status
   */
  async getUserAnalysis() {
    const response = await apiClient.get('/api/user_analysis')
    if (response.status === 202) {
      return response.data
    }
    return response.data.data || response.data
  },
}
